const es = {
  common: {
    admin: 'ADMIN',
    sysadmin: 'sysadmin',
    eventadmin: 'eventadmin',
    noRole: 'sin acceso',
    anonymous: 'Anónimo',
    logout: 'Cerrar sesión',
    back: 'Volver',
    cancel: 'Cancelar',
    save: 'Guardar cambios',
    edit: 'Editar',
    delete: 'Eliminar',
    remove: 'Quitar',
    add: 'Agregar',
    create: 'Crear',
    close: 'Cerrar',
    saving: 'Guardando...',
    creating: 'Creando...',
    uploading: 'Subiendo...',
    adding: 'Agregando...',
    loading: 'Cargando...',
    download: 'Descargar',
    copyLink: 'Copiar enlace',
    next: 'Siguiente',
    prev: 'Anterior',
    loadMore: 'Cargar más',
    noPermission: 'No tienes permiso para ver esta página.',
    anonymousNotice: 'Has iniciado sesión como anónimo. Cierra sesión y usa una cuenta de administrador válida.',
    urlCopied: 'URL copiada al portapapeles',
    linkCopied: 'Enlace copiado al portapapeles',
    downloadFailed: 'Error al descargar',
    preparingDownload: 'Preparando descarga...',
    share: 'Compartir',
    shareFailed: 'Error al compartir',
    preparingShare: 'Preparando video...',
  },
  nav: {
    events: 'Eventos',
    users: 'Usuarios',
    eventTypes: 'Tipos de Evento',
    templates: 'Plantillas',
  },
  login: {
    title: 'Panel de administración',
    subtitle: 'Inicia sesión para gestionar eventos, usuarios y moderación.',
    email: 'Correo electrónico',
    emailPlaceholder: 'tu@ejemplo.com',
    password: 'Contraseña',
    passwordPlaceholder: '••••••••',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    signIn: 'Iniciar sesión',
    forgotPassword: '¿Olvidaste tu contraseña?',
    emailRequired: 'El correo electrónico es obligatorio',
    emailInvalid: 'Ingresa una dirección de correo válida',
    passwordRequired: 'La contraseña es obligatoria',
    loginFailed: 'Error al iniciar sesión',
    enterEmailFirst: 'Ingresa tu correo primero',
    enterEmailFirstDesc: 'Escribe tu correo arriba, luego haz clic en este enlace.',
    resetEmailSent: 'Correo de restablecimiento enviado',
    resetEmailSentDesc: 'Revisa {email} para encontrar el enlace de restablecimiento.',
    resetEmailFailed: 'No se pudo enviar el correo de restablecimiento',
    resetTooMany: 'Demasiadas solicitudes para este correo. Espera unos minutos e inténtalo de nuevo.',
  },
  events: {
    title: 'Eventos',
    streamingAndGallery: 'Streaming y galería',
    enableStreaming: 'Streaming Cloudflare y galería pública',
    streamingSysadminOnly: 'Solo un sysadmin puede cambiar esto',
    galleryPublic: 'Galería visible públicamente',
    galleryPublicHint: 'Si está desactivado, solo las cuentas registradas ven los videos de este evento. Los reels siempre son públicos.',
    galleryUrl: 'Enlace de la galería',
    galleryQrTitle: 'Código QR de la galería',
    backfillPending: 'Algunos videos aún no se han enviado a Cloudflare.',
    sendRemaining: 'Enviar pendientes',
    sendRemainingDone: 'Enviados {count}, {remaining} pendientes',
    backfillAuthors: 'Actualizar nombres de creadores',
    backfillAuthorsHint: 'Agrega el nombre del creador a los elementos de la galería publicados antes de que se registraran los nombres, recuperándolo del registro de ingreso cuando hace falta. No se vuelve a codificar nada.',
    backfillAuthorsDone: 'Actualizados {updated} de {scanned} elementos, {recovered} nombres recuperados',
    subtitle: 'Lista, ordena y entra al control o moderación.',
    sortByPlaceholder: 'Ordenar por',
    sortByName: 'Ordenar por nombre',
    sortByCreated: 'Ordenar por fecha de creación',
    filterAllTypes: 'Todos los tipos',
    createEvent: 'Crear evento',
    closeCreator: 'Cerrar creador',
    whatKind: '¿Qué tipo de evento?',
    normalEvent: 'Evento normal',
    wedding: 'Boda',
    failedToLoad: 'Error al cargar eventos',
    untitled: 'Evento sin título',
    moderation: 'Moderación',
    videos: 'Videos',
    reels: 'Reels',
    prizes: 'Premios',
    eventName: 'Nombre del evento',
    eventNamePlaceholder: 'Haz clic para establecer el nombre',
    eventNameEditPlaceholder: 'Nombre del evento',
    eventDeleted: 'Evento eliminado',
    eventDeleteFailed: 'Error al eliminar el evento',
    eventUpdated: 'Evento actualizado',
    eventUpdateFailed: 'Error al actualizar el evento',
    allEventsLink: '← Todos los eventos',
    deleteEventTitle: 'Eliminar evento',
    deleteEventConfirm: '¿Seguro que quieres eliminar {name}? Todo lo que le pertenece se eliminará de forma permanente: videos y reels (incluidas sus copias en Cloudflare y sus enlaces compartidos), premios, analíticas, roles del equipo, configuración e imágenes subidas. Esta acción no se puede deshacer.',
    deleteEventAria: 'Eliminar evento',
    images: 'Imágenes',
    themeColors: 'Colores del tema',
    challengeBackground: 'Fondo del reto',
    logo: 'Logo',
    prizeBackground: 'Fondo del premio',
    splashScreen: 'Pantalla de inicio',
    backgroundColor: 'Fondo',
    surfaceColor: 'Superficie',
    primaryColor: 'Primario',
    textColor: 'Texto',
    challengePrompt: 'Instrucciones del reto',
    challengePromptPlaceholder: 'ej. ¡Elige un reto y graba un video!',
    promptColor: 'Color del texto',
    maxVideosPerUser: 'Máximo de videos por usuario',
    maxVideosPlaceholder: 'Sin límite',
    maxVideosHelp: 'Déjalo vacío para ilimitado. Solo aplica cuando el Modo Premio está desactivado.',
    prizeMode: 'Modo Premio',
    enablePrizeMode: 'Activar Modo Premio',
    enablePrizeModeHelp: 'Los usuarios deben completar todos los retos para ganar un premio.',
    requireLogin: 'Requerir inicio de sesión',
    requireLoginHelp: 'Si está desactivado, los usuarios anónimos pueden participar pero pueden perder su progreso.',
    maxRejections: 'Máximo de rechazos por reto',
    prizeConfig: 'Configuración del premio',
    prizeTitle: 'Título del premio',
    prizeTitlePlaceholder: '¡Felicidades!',
    prizeDescription: 'Descripción del premio',
    prizeDescriptionPlaceholder: 'Muestra este código QR para reclamar tu premio en el stand',
    prizePrompt: 'Mensaje del premio',
    prizePromptPlaceholder: '¡Muestra este QR al personal para reclamar tu premio!',
    validatorCodes: 'Códigos de acceso del validador',
    validatorCodesHelp: 'Comparte estos códigos con el personal del evento que validará los QR de premios.',
    generateValidatorCode: 'Generar nuevo código',
    copyValidatorUrl: 'Copiar URL del validador',
    videoCountOne: '{count} video',
    videoCountMany: '{count} videos',
    reelCountOne: '{count} reel',
    reelCountMany: '{count} reels',
    showQrCode: 'Mostrar código QR',
    removeCode: 'Quitar código',
    validatorQrTitle: 'Código QR del validador',
    recordingSettings: 'Configuración de grabación',
    maxSegmentDuration: 'Duración máxima del segmento (segundos)',
    maxSegmentDurationHelp: 'Longitud máxima del clip recortado que los usuarios pueden enviar.',
    maxRecordingDuration: 'Duración máxima de grabación (segundos)',
    maxRecordingDurationHelp: 'Tiempo máximo que la cámara grabará antes de detenerse automáticamente.',
    videoReception: 'Recepción de videos',
    acceptSubmissions: 'Aceptar envíos de video',
    acceptSubmissionsHelp: 'Si está desactivado, la webapp no permitirá subir nuevos videos.',
    receptionStart: 'Inicio de recepción',
    receptionEnd: 'Fin de recepción',
    moderationSettings: 'Configuración de moderación',
    autoApprove: 'Aprobar automáticamente videos nuevos',
    autoApproveHelp: 'Si está activado, los videos subidos saltan la cola de moderación.',
    infoSection: 'Info y Términos (webapp)',
    infoSectionHelp: 'Contenido Markdown que se muestra en el menú Info de la webapp. Soporta encabezados, listas, negrita, cursiva, enlaces.',
    infoPlaceholder: 'Escribe el contenido de info / términos en Markdown...',
    infoResetDefault: 'Restablecer predeterminado',
  },
  qr: {
    title: 'Código QR',
    placeholder: 'El código QR se generará cuando se cree el evento',
    copyEventUrl: 'Copiar URL del evento',
    downloadQr: 'Descargar QR',
  },
  eventBackground: {
    noImage: 'Este evento no tiene una imagen de {name}.',
    dropReplace: 'Suelta para reemplazar {name}',
    dropImage: 'Suelta la imagen de {name} aquí o haz clic para subir',
    removeImage: 'Quitar imagen de {name}',
    colorSuffix: 'Color de {name}',
  },
  eventUsers: {
    title: 'Administradores del evento',
    notCreatedYet: 'Podrás agregar usuarios una vez que se cree el evento.',
    loadingUser: 'Cargando usuario...',
    loadingError: 'Error al cargar usuario: {message}',
    loadingAdmins: 'Cargando administradores del evento...',
    loadingAdminsError: 'Error al cargar administradores del evento: {message}',
    addAdminUser: 'Agregar administrador',
    userEmail: 'Correo del usuario',
    role: 'Rol',
    eventAdmin: 'Administrador del evento',
    moderator: 'Moderador',
    weddingOrganizer: 'Organizador de la boda',
    typeOrganizer: 'Organizador de {{type}}',
    adding: 'Agregando...',
    removeTitle: 'Quitar usuario',
    removeConfirm: '¿Quitar a {user} de este evento? Perderá el acceso al mismo.',
    removing: 'Quitando...',
    removed: 'Usuario quitado del evento',
    removeFailed: 'No se pudo quitar al usuario: {message}',
  },
  challenges: {
    title: 'Retos',
    name: 'Nombre del reto',
    background: 'Fondo',
    text: 'Texto',
    selfieCamera: 'Cámara selfie',
    deleteAria: 'Eliminar reto',
    addChallenge: 'Agregar nuevo reto',
  },
  wedding: {
    createTitle: 'Crear evento de boda',
    createButton: 'Crear evento de boda',
    couple: 'Pareja',
    couplePlaceholder: 'ej. Alex y Sam',
    coupleHelp: 'Se usa como nombre del evento.',
    receptionStart: 'Inicio de la recepción',
    receptionEnd: 'Fin de la recepción',
    adminEmail: 'Correo del organizador',
    adminEmailPlaceholder: 'organizador@ejemplo.com',
    adminEmailHelp: 'Se invitará como organizador de la boda para este evento.',
    coupleRequired: 'El nombre de la pareja es obligatorio',
    startRequired: 'La fecha y hora de inicio es obligatoria',
    endRequired: 'La fecha y hora de fin es obligatoria',
    endAfterStart: 'El fin debe ser posterior al inicio',
    adminEmailRequired: 'El correo del organizador es obligatorio',
    emailInvalid: 'Ingresa un correo válido',
    created: 'Evento de boda creado',
    inviteFailed: 'Evento creado — falló la invitación del administrador',
    inviteFailedDesc: '{message}. Invita al organizador desde la configuración del evento.',
    createFailed: 'Error al crear el evento de boda',
    unknownError: 'Error desconocido',
  },
  moderation: {
    loading: 'Cargando moderación...',
    noAccess: 'Sin acceso a este evento',
    grid: 'Cuadrícula',
    inQueue: '{count} en cola',
    nextVideos: 'Siguientes videos',
    filterPending: 'Pendientes',
    filterAll: 'Todos',
    filterAccepted: 'Aceptados',
    filterRejected: 'Rechazados',
    loadingVideos: 'Cargando videos…',
    noVideosFilter: 'No hay videos para este filtro.',
    keyboardHints: '←↑↓→ navegar · A aceptar · X rechazar · F favorito · Espacio iniciar/pausar',
    rejectAll: 'Rechazar todos',
    acceptAll: 'Aceptar todos',
    failedToLoad: 'Error al cargar videos',
    bulkSuccess: 'Se {action} {count} videos en lote',
    bulkActionAccepted: 'aceptaron',
    bulkActionRejected: 'rechazaron',
    bulkFailed: 'Error en la moderación en lote',
    statusAccepted: 'Aceptado',
    statusRejected: 'Rechazado',
    statusInModeration: 'En moderación',
    statusPending: 'Pendiente',
    start: 'MODERAR',
    pause: 'PAUSA',
    pausedTitle: 'MODERACIÓN EN PAUSA',
    you: 'tú',
    holdingCount: 'con {count}',
    takenOver: 'Tomado por otro moderador',
    decidedElsewhere: 'Decidido por otro moderador',
    waitingBanner: '{count} videos te están esperando',
    backToModeration: 'Volver a moderar',
    acceptWatched: 'Aceptar vistos ({count})',
    rejectWatched: 'Rechazar vistos ({count})',
    moreOptions: 'Más opciones',
    pageInfo: '{page} / {total} ({count} en total)',
    rejectAria: 'Rechazar',
    acceptAria: 'Aceptar',
    favoriteAria: 'Favorito',
    aiOverrideTitle: 'La IA rechazó {count} videos que habías aprobado',
    aiOverrideBody: 'Se detectó contenido explícito después de aprobar el video. Fue despublicado y retirado de la galería.',
    aiOverrideAck: 'Entendido',
    aiOverrideAckAll: 'Entendido todo',
  },
  videosPage: {
    ownerFilter: 'Videos de {name} · {shown} de {total}',
    ownerFilterClear: 'Ver los videos de todos',
    reanalyze: 'Reanalizar con IA',
    reanalyzeStarted: 'Reanálisis iniciado',
    reanalyzeFailed: 'No se pudo reanalizar',

    breadcrumb: 'Videos',
    streamProcessing: 'Preparando streaming…',
    streamError: 'Falló el streaming',
    streamRetry: 'Reintentar streaming',
    streamRetryQueued: 'Enviado a Cloudflare nuevamente',
    streamRetryFailed: 'No se pudo reintentar',
    titleSuffix: '{name} - Videos',
    countSuffix: '{count} videos',
    selectPageSize: 'Selecciona tamaño de página',
    perPage: '{n} por página',
    pageSizeAll: 'Todos',
    gridView: 'Vista de cuadrícula',
    listView: 'Vista de lista',
    exportVideos: 'Exportar videos',
    deleteAll: 'Eliminar todos',
    deleteAllTitle: 'Eliminar todos los videos',
    deleteAllConfirm: '¿Seguro que quieres eliminar los {count} videos de este evento? Se eliminarán los archivos de video y sus registros. Esta acción no se puede deshacer.',
    deleteAllButton: 'Eliminar todos los videos',
    deleted: 'Se eliminaron {count} videos',
    deleteFailed: 'Error al eliminar videos',
    noVideos: 'No se encontraron videos para este evento.',
    play: 'Reproducir',
    pause: 'Pausar',
    favorite: 'Favorito',
    unfavorite: 'Quitar de favoritos',
    openViewer: 'Abrir visor',
    downloadVideo: 'Descargar video',
    expand: 'Expandir',
    playPause: 'Reproducir/Pausar',
    rotate: 'Rotar 90°',
    forceVertical: 'Forzar vertical',
    unforceVertical: 'Quitar vertical',
    sortLabel: 'Ordenar videos',
    sortCreatedDesc: 'Más recientes primero',
    sortCreatedAsc: 'Más antiguos primero',
    sortDurationDesc: 'Más largos primero',
    sortDurationAsc: 'Más cortos primero',
    sortChallenge: 'Por desafío',
    deleteVideo: 'Eliminar video',
    deleteVideoTitle: '¿Eliminar este video?',
    deleteVideoConfirm: 'El video se elimina de todas partes: su archivo, su copia de streaming, su análisis de IA, la galería y esta lista. No se puede deshacer.',
    deleteVideoButton: 'Eliminar video',
    videoDeleted: 'Video eliminado',
    videoDeleteFailed: 'No se pudo eliminar el video',
    moreInfo: 'Más información',
    moreActions: 'Más acciones',
    sendToStream: 'Enviar {count} a Cloudflare',
    sendToStreamDone: 'Se enviaron {count} videos a Cloudflare',
    sendToStreamRemaining: 'Faltan {count} por enviar: vuelve a pulsar el botón.',
    sendToStreamFailed: 'No se pudieron enviar los videos a Cloudflare',
    removeStreamCopy: 'Eliminar copia en Cloudflare',
    streamCopyRemoved: 'Copia en Cloudflare eliminada',
    streamCopyRemoveFailed: 'No se pudo eliminar la copia en Cloudflare',
    streamRemoved: 'No está en Cloudflare (copia eliminada)',
    infoTitle: 'Detalles del video',
    infoOwner: 'Enviado por',
    infoOwnerName: 'Nombre',
    infoOwnerEmail: 'Correo',
    infoOwnerUid: 'ID de usuario',
    infoOwnerUnknown: 'Desconocido',
    infoOwnerFailed: 'No se pudo identificar a quien lo envió',
    infoAllByUser: 'Todos los videos de esta persona',
    infoId: 'ID del video',
  },
  exportDialog: {
    title: 'Exportar videos',
    summary: 'Se recortarán {count} videos aceptados, se convertirán a MP4 y se comprimirán en un zip.',
    recipients: 'Enviar a',
    recipientsPlaceholder: 'nombre@ejemplo.com',
    recipientsHelp: 'Presiona Enter después de cada dirección. Siempre recibes una copia.',
    invalidEmail: 'Eso no parece una dirección de correo.',
    removeRecipient: 'Quitar a {email}',
    access: 'Acceso al enlace',
    restricted: 'Restringido — solo las personas de esta lista',
    restrictedHelp: 'Los destinatarios inician sesión para descargar. Quien no tenga cuenta recibirá una y creará su contraseña.',
    public: 'Cualquier persona con el enlace',
    publicHelp: 'Sin iniciar sesión. Cualquiera que reciba el enlace puede descargar los videos.',
    includeReels: 'Incluir los {count} reels, en su propia carpeta',
    start: 'Exportar',
    started: 'Exportando {count} videos',
    reused: 'No ha cambiado nada — se reutiliza la exportación existente',
    emailWhenReady: 'Recibirás un correo cuando el zip esté listo.',
    failed: 'No se pudo iniciar la exportación',
    reuseNotice: 'Ya existe una exportación de estos mismos videos, del {date}. Se compartirá de nuevo en vez de volver a procesarla.',
    runningNotice: 'Ya hay una exportación de estos videos en curso. Los destinatarios que agregues recibirán el correo cuando termine.',
    rebuild: 'Volver a procesar',
    previewFailed: 'No se pudieron cargar los detalles de la exportación — no están disponibles la comprobación de reutilización ni la opción de reels. Igual puedes iniciar una exportación.',
  },
  exportList: {
    title: 'Exportaciones',
    videos: '{count} videos',
    recipients: '{count} destinatarios',
    progress: '{done} de {total} procesados',
    failed: '{count} con error',
    open: 'Abrir',
    delete: 'Eliminar esta exportación',
    deleteTitle: '¿Eliminar esta exportación?',
    deleteConfirm: 'El zip y sus enlaces de descarga dejan de funcionar de inmediato, para los {count} destinatarios. Los videos del evento no se ven afectados. Esto no se puede deshacer.',
    deleteButton: 'Eliminar exportación',
    deleted: 'Exportación eliminada',
    deleteFailed: 'No se pudo eliminar la exportación',
    mailFailed: 'Listo, pero no se pudo enviar el correo de notificación.',
    status: {
      queued: 'En cola',
      processing: 'Procesando',
      zipping: 'Comprimiendo',
      ready: 'Listo',
      error: 'Con error',
    },
  },
  displayControls: {
    enable: 'Controles de pantalla',
    enabled: 'Controles de pantalla activos',
    confirmTitle: '¿Activar los controles de pantalla?',
    confirmBody: 'Los botones de rotación y forzar vertical cambian cómo se ve cada video en la transmisión en vivo que se muestra en las pantallas mediante la app de reproducción de escritorio. Úsalos solo si sabes para qué sirven.',
    confirmButton: 'Activar',
  },
  reels: {
    breadcrumb: 'Reels',
    streamProcessing: 'Preparando streaming…',
    streamError: 'Falló el streaming',
    streamRetry: 'Reintentar streaming',
    sendExisting: 'Enviar reels existentes a Cloudflare',
    sendExistingDone: '{count} reels encolados',
    titleSuffix: '{name} — Reels',
    countOne: '{count} reel',
    countMany: '{count} reels',
    uploadReel: 'Subir Reel',
    uploading: 'Subiendo...',
    uploadingProgress: 'Subiendo... {percent}%',
    uploaded: 'Reel subido',
    uploadFailed: 'Error al subir',
    deleted: 'Reel eliminado',
    deleteFailed: 'Error al eliminar',
    deleteConfirm: '¿Eliminar "{name}"? Esto no se puede deshacer.',
    noReels: 'Aún no hay reels. Sube un video para comenzar.',
    shareTitle: 'Compartir reel',
    shareLink: 'Enlace para compartir',
    shareNotReady: 'Disponible cuando el video termine de procesarse para streaming',
    shareFailed: 'Error al crear el enlace de compartir',
    favorite: 'Favorito',
    unfavorite: 'Quitar de favoritos',
    favoriteNote: 'Solo los reels marcados como favoritos se muestran en la galería del evento.',
    disable: 'Deshabilitar reel',
    enable: 'Habilitar reel',
    disabledBadge: 'Deshabilitado',
    disableNote: 'Oculta el reel de la galería y de su enlace para compartir. No se elimina nada.',
    shareDisabled: 'Este reel está deshabilitado, por lo que su enlace muestra que el video no está disponible',
    openViewer: 'Abrir visor',
    play: 'Reproducir',
    pause: 'Pausar',
    playPause: 'Reproducir/Pausar',
    downloadVideo: 'Descargar video',
    deleteReel: 'Eliminar reel',
    expand: 'Expandir',
    share: 'Compartir',
    delete: 'Eliminar',
    edit: 'Editar',
    editReel: 'Editar reel',
    editTitle: 'Editar Reel',
    nameDialogTitle: 'Nombra este reel',
    thumbnail: 'Miniatura',
    thumbnailHelp: 'El fotograma que se muestra antes de reproducir el reel, en la galería y en su página para compartir.',
    thumbnailPending: 'Disponible cuando el reel termine de procesarse para streaming.',
    thumbnailFailed: 'No se pudo cargar este fotograma.',
    reelName: 'Nombre',
    reelNamePlaceholder: 'Nombre del reel',
    file: 'Archivo',
    replaceFile: 'Reemplazar archivo',
    chooseFile: 'Elegir archivo…',
    replaceFileHelp: 'Sube un nuevo video en su lugar. El reel conserva su id, por lo que su enlace y su QR siguen siendo válidos, pero la página compartida no estará disponible hasta que el nuevo streaming termine de procesarse.',
    newFileSelected: 'Nuevo archivo: {name}',
    save: 'Guardar',
    saved: 'Reel actualizado',
    saveFailed: 'Error al actualizar el reel',
    replacing: 'Reemplazando... {percent}%',
  },
  prizes: {
    breadcrumb: 'Premios',
    title: 'Canjes de premios',
    redeemed: '{count} canjeados',
    active: '{count} activos',
    total: '{count} en total',
    none: 'Aún no se han generado premios para este evento.',
    columnUid: 'UID del usuario',
    columnStatus: 'Estado',
    columnCreated: 'Creado',
    columnRedeemed: 'Canjeado el',
    columnRedeemedBy: 'Canjeado por',
  },
  users: {
    title: 'Usuarios',
    subtitle: 'Todas las cuentas: equipo y participantes.',
    filterStaff: 'Equipo',
    filterParticipants: 'Participantes',
    filterAll: 'Todas',
    searchPlaceholder: 'Buscar por nombre, o un email o uid exacto',
    search: 'Buscar',
    clearSearch: 'Limpiar',
    loadMore: 'Cargar más',
    loadFailed: 'No se pudieron cargar los usuarios: {message}',
    empty: 'Aún no hay cuentas aquí.',
    noMatch: 'Ninguna cuenta coincide con “{query}”.',
    anonymous: 'Anónimo',
    badgeSysadmin: 'Sysadmin',
    badgeSeller: 'Vendedor',
    badgeSalesmanager: 'Jefe de ventas',
    badgeDisabled: 'Acceso desactivado',
    eventCount: '{count} eventos',
    eventCountOne: '1 evento',
    lastSignIn: 'Último acceso {date}',
    neverSignedIn: 'Nunca ha entrado',
    back: 'Todos los usuarios',
    notFound: 'Esta cuenta ya no existe.',
    you: 'Tú',
    account: {
      title: 'Cuenta',
      email: 'Email',
      name: 'Nombre',
      uid: 'UID',
      providers: 'Métodos de acceso',
      created: 'Creada',
      lastSignIn: 'Último acceso',
      status: 'Acceso',
      enabled: 'Permitido',
      disabled: 'Desactivado',
      disable: 'Desactivar acceso',
      enable: 'Permitir acceso',
      disabledToast: 'Acceso desactivado. Se cerró su sesión.',
      enabledToast: 'Acceso permitido de nuevo.',
      sendReset: 'Enviar cambio de contraseña',
      resetSent: 'Cambio de contraseña enviado a {email}',
      selfNote: 'Esta es tu propia cuenta.',
    },
    platform: {
      title: 'Roles de plataforma',
      sysadmin: 'Sysadmin',
      sysadminHelp: 'Acceso total a todos los eventos, usuarios y ajustes.',
      granted: 'Sysadmin otorgado. Aplica en su próximo acceso o dentro de una hora.',
      revoked: 'Sysadmin quitado. Se cerró su sesión.',
      sales: 'Ventas',
      salesNone: 'No está en el equipo de ventas.',
      salesRoleSeller: 'Vendedor',
      salesRoleSalesmanager: 'Jefe de ventas',
      salesActive: 'Activo',
      salesInactive: 'Inactivo',
      salesActivate: 'Activar',
      salesDeactivate: 'Desactivar',
      salesRoleChanged: 'Rol de ventas cambiado.',
      salesActiveChanged: 'Acceso a ventas actualizado.',
      enrol: 'Agregar al equipo de ventas',
      enrolName: 'Nombre',
      enrolKind: 'Tipo',
      enrolKindInternal: 'Interno (acceso con Google)',
      enrolKindExternal: 'Externo (contraseña)',
      enrolRole: 'Rol',
      enrolCommission: 'Comisión %',
      enrolSubmit: 'Agregar y enviar invitación',
      enrolled: 'Agregado al equipo de ventas e invitado.',
      needsEmail: 'Una cuenta sin email no puede unirse al equipo de ventas.',
    },
    events: {
      title: 'Eventos',
      none: 'Sin rol en ningún evento.',
      event: 'Evento',
      role: 'Rol',
      add: 'Agregar a evento',
      pickEvent: 'Elige un evento',
      untitled: '(evento sin nombre)',
      missingEvent: 'Evento eliminado',
      added: 'Rol agregado.',
      changed: 'Rol cambiado.',
      removed: 'Quitado del evento.',
      remove: 'Quitar del evento',
    },
    roles: {
      eventadmin: 'Admin del evento',
      moderator: 'Moderador',
      basic: 'Básico',
      weddingadmin: 'Organizador de matrimonio',
    },
    content: {
      title: 'Videos enviados',
      none: 'Sin videos.',
      summary: '{videos} videos en {events} eventos',
      counts: '{accepted} aceptados · {pending} pendientes · {rejected} rechazados',
    },
    danger: {
      title: 'Quitar a esta persona',
      removeAccess: 'Quitar acceso',
      removeAccessHelp: 'Quita todos sus roles y permisos. Su cuenta y sus videos quedan.',
      delete: 'Eliminar cuenta',
      deleteHelp: 'Elimina su cuenta y, si quieres, todos los videos que envió.',
    },
    delete: {
      titleAccess: '¿Quitar todo su acceso?',
      titleAccount: '¿Eliminar esta cuenta?',
      keepVideos: 'Mantener sus videos',
      alsoVideos: 'Eliminar también sus {videos} videos',
      willRemove: 'Se eliminará',
      willKeep: 'Se mantendrá',
      irreversible: 'Esto no se puede deshacer.',
      typeToConfirm: 'Escribe {target} para confirmar',
      confirmAccess: 'Quitar acceso',
      confirmAccount: 'Eliminar cuenta',
      confirmEverything: 'Eliminar cuenta y videos',
      working: 'Eliminando…',
      tryAgain: 'Reintentar',
      partial: 'Algunas cosas no se pudieron eliminar. Su cuenta se mantuvo para que puedas reintentar:',
      doneAccess: 'Acceso quitado.',
      doneAccount: 'Cuenta eliminada.',
      lines: {
        eventRoles: 'Sus roles en {count} eventos',
        sysadmin: 'Acceso de sysadmin',
        salesAccess: 'Acceso a la app de ventas',
        profile: 'Su perfil de usuario y avatar',
        login: 'Su cuenta de acceso',
        videos: '{videos} videos en {events} eventos, con sus copias de streaming, archivos, análisis de IA y entradas en la galería',
        salesRecord: 'Su ficha de ventas, marcada inactiva (las ventas cerradas y comisiones la usan)',
        eventContent: 'Reels, exportaciones y eventos que creó — pertenecen al evento',
      },
    },
  },
  shared: {
    notFound: 'Video no encontrado',
    loadFailed: 'Error al cargar el video',
    streamUnavailable: 'Este video ya no está disponible para streaming',
    unavailable: 'Este video ya no está disponible',
    fullscreen: 'Pantalla completa',
    downloadVideo: 'Descargar video',
    shareVideo: 'Compartir video',
  },
  language: {
    label: 'Idioma',
  },
  eventTypes: {
    changeTitle: 'Cambiar tipo de evento',
    changeType: 'Tipo',
    changeUrl: 'URL de la webapp',
    changeFields: 'Aplicar los valores por defecto del nuevo tipo cambiaría estos campos:',
    changeNoFields: 'Ningún campo predefinido cambia; solo cambian el tipo y la URL.',
    changePreserveNote: 'El nombre, los desafíos, las imágenes y demás contenido se conservan en ambos casos.',
    changeTypeOnly: 'Cambiar solo el tipo',
    changeTypeOnlyTip: 'Cambia el tipo y la URL de la webapp, y nada más. Todos los ajustes conservan su valor actual, aunque el valor por defecto del nuevo tipo sea distinto.',
    changeApplyDefaults: 'Cambiar y aplicar valores por defecto',
    changeApplyDefaultsTip: 'Cambia el tipo y la URL de la webapp, y restablece estos ajustes a los valores por defecto del nuevo tipo:',
    changeApplyDefaultsNone: 'Los valores por defecto del nuevo tipo ya coinciden con este evento; no hay nada que aplicar.',
    changed: 'Tipo de evento cambiado',
    changeFailed: 'No se pudo cambiar el tipo de evento',
    title: 'Tipos de Evento',
    subtitle: 'Configura los valores y el comportamiento por tipo de evento',
    slug: 'slug',
    entryFlow: 'ingreso',
    labelEn: 'Etiqueta (EN)',
    labelEs: 'Etiqueta (ES)',
    tagColor: 'Color de etiqueta',
    adminRole: 'Rol de administrador',
    capModeration: 'Moderación',
    capPrizes: 'Premios',
    hiddenSections: 'Secciones ocultas',
    defaults: 'Valores por defecto',
    saved: 'Tipo de evento guardado',
    saveFailed: 'No se pudo guardar el tipo de evento',
    seed: 'Sembrar valores',
    seeded: 'Se crearon {{count}} tipo(s)',
    seedFailed: 'No se pudieron sembrar los tipos',
  },
  templates: {
    title: 'Plantillas de correo',
    subtitle: 'Texto por defecto de cada correo que envía la plataforma. Los eventos parten de estas.',
    eventTitle: 'Plantillas de correo',
    eventSubtitle: 'Correos que reciben los participantes y administradores de este evento. Se prellenan desde las plantillas por defecto.',
    language: 'Idioma de los correos',
    languageHelp: 'Idioma en que se envían los correos de este evento.',
    subject: 'Asunto',
    body: 'Cuerpo HTML',
    text: 'Texto',
    placeholders: 'Variables — haz clic para insertar',
    unknownPlaceholders: 'Variable(s) desconocida(s): {names}. No se reemplazan y se enviarán tal cual.',
    showPreview: 'Vista previa',
    hidePreview: 'Ocultar vista previa',
    restoreDefault: 'Restaurar por defecto',
    saved: 'Plantilla guardada',
    saveFailed: 'No se pudo guardar la plantilla',
    testTo: 'Enviar una prueba a',
    testSend: 'Enviar prueba',
    testSending: 'Enviando…',
    testHelp: 'Se envía con valores de ejemplo y el prefijo [TEST] en el asunto. Envía lo que ves en pantalla, guardado o no.',
    testSent: 'Correo de prueba enviado a {email}',
    testFailed: 'No se pudo enviar el correo de prueba',
    name: {
      invite: 'Invitación de administrador',
      roleAdded: 'Agregado a un evento',
      prize: 'Premio ganado',
      contact: 'Formulario de contacto',
      videoExportReady: 'Exportación de videos lista',
      videoExportInvite: 'Exportación de videos lista (cuenta nueva)',
      videoExportFailed: 'Exportación de videos fallida',
      sellerInvite: 'Invitación de vendedor (contraseña)',
      sellerInviteGoogle: 'Invitación de vendedor (Google)',
      salesReminder: 'Recordatorio diario de ventas',
      passwordReset: 'Restablecer contraseña',
      reelShare: 'Texto al compartir un reel',
    },
    description: {
      invite: 'Se envía cuando se invita a un administrador y debe crear su contraseña.',
      roleAdded: 'Se envía cuando se agrega a un evento a alguien que ya tiene cuenta.',
      prize: 'Se envía a un participante que completó todos los desafíos.',
      contact: 'Se envía a hola@crowds.cl desde el formulario de contacto del landing.',
      videoExportReady: 'Se envía cuando termina una exportación de videos, a todos los destinatarios.',
      videoExportInvite: 'Se envía cuando el destinatario aún no tiene contraseña y la exportación es privada.',
      videoExportFailed: 'Se envía a quien inició la exportación cuando falla, para que nadie quede esperando un enlace que no va a llegar. A los destinatarios no se les avisa.',
      sellerInvite: 'Se envía a un vendedor externo, con un link para crear su contraseña.',
      sellerInviteGoogle: 'Se envía a un vendedor interno, que entra con Google.',
      salesReminder: 'Un correo por vendedor cada mañana con los leads para hoy o atrasados.',
      passwordReset: 'Se envía cuando alguien usa "¿Olvidaste tu contraseña?" en el admin, la webapp o la app de ventas.',
      reelShare: 'No es un correo: el texto que adjunta el teléfono de un invitado al compartir uno de los reels del evento (en Instagram se copia al portapapeles). El enlace al reel se agrega al final automáticamente.',
    },
  },
  exportPage: {
    count: '{count} videos',
    failed: '{count} no se pudieron procesar',
    partSize: '{count} videos · {size} MB',
    download: 'Descargar',
    expires: 'Este enlace funciona hasta el {date}.',
    unavailable: 'Esta exportación no está disponible',
    error: {
      denied: 'Esta exportación no fue compartida con la cuenta con la que iniciaste sesión.',
      notReady: 'Esta exportación todavía se está preparando. Inténtalo de nuevo en unos minutos.',
      gone: 'El enlace expiró o la exportación ya no existe. Pide una nueva a quien la compartió.',
      deleted: 'Un administrador del evento eliminó esta exportación, así que los videos ya no están disponibles aquí. Si todavía los necesitas, pídeselos a quien te la compartió \u2014 puede prepararla de nuevo.',
      temporary: 'Algo salió mal al preparar esta descarga. Inténtalo de nuevo en unos minutos: si sigue ocurriendo, contacta a quien te la compartió.',
    },
  },
  analytics: {
    title: 'Analíticas',
    navLink: 'Analíticas',
    breadcrumb: 'Analíticas',
    lastUpdated: 'Última actualización: {date}',
    notYetComputed: 'Aún no calculado',
    recompute: 'Recalcular',
    recomputing: 'Recalculando...',
    recomputeSuccess: 'Analíticas recalculadas. {remaining} cálculos restantes hoy.',
    recomputeUnlimited: 'Analíticas recalculadas.',
    recomputeLimitReached: 'Límite diario de cálculos alcanzado. Inténtalo de nuevo mañana.',
    recomputeError: 'Error al recalcular las analíticas.',
    emptyState: 'Sin analíticas aún — haz clic en Recalcular para generarlas.',
    tier: 'Nivel de analíticas',
    tierFree: 'Gratis',
    tierPro: 'Pro',
    metricUsableRate: 'Tasa de contenido utilizable',
    metricSubmissions: 'Envíos',
    metricAccepted: 'Aceptados',
    metricRejected: 'Rechazados',
    metricParticipants: 'Participantes únicos',
    metricSubmissionsPerParticipant: 'Envíos / participante',
    metricRedemptionRate: 'Tasa de canje',
    metricAvgDuration: 'Duración promedio del clip',
    secondsUnit: '{value}s',
    peakTimesTitle: 'Horas pico de envíos',
    hourLabel: '{hour}:00',
    timezoneLabel: 'Zona horaria',
    challengeBreakdownTitle: 'Desglose por reto',
    colChallenge: 'Reto',
    colSubmissions: 'Envíos',
    colAccepted: 'Aceptados',
    colRejected: 'Rechazados',
    colAcceptRate: 'Tasa de aceptación',
    costCalculatorTitle: 'Calculadora de costos',
    costInput: 'Costo total del evento',
    costStorageNote: 'Este valor se guarda solo en tu navegador.',
    costPerScan: 'Costo por escaneo',
    costPerParticipant: 'Costo por participante',
    costPerSubmission: 'Costo por envío',
    costPerUsableClip: 'Costo por clip utilizable',
    costPerRedemption: 'Costo por canje',
  },
  videoAI: {
    backfillStarted: 'Analizando {count} videos en segundo plano. Puedes salir de esta página.',

    title: 'Análisis de video con IA',
    enable: 'Activar análisis de video con IA',
    featuresLabel: 'Detecciones a ejecutar',
    featureExplicit: 'Detección de contenido explícito',
    featureFace: 'Detección de rostros',
    featureLabel: 'Detección de etiquetas',
    featureLogo: 'Reconocimiento de logos',
    featureObject: 'Seguimiento de objetos',
    featurePerson: 'Detección de personas',
    featureSpeech: 'Transcripción de voz',
    featureText: 'Detección de texto',
    aiModeration: 'Moderación por IA (rechazar videos explícitos automáticamente)',
    thresholdLabel: 'Rechazar cuando el contenido explícito sea al menos',
    thresholdPOSSIBLE: 'Posible',
    thresholdLIKELY: 'Probable',
    thresholdVERY_LIKELY: 'Muy probable',
    costLine: 'Costo estimado: {perSecond} por segundo de video ({perMinute}/min).',
    costFree: 'Los primeros {minutes} minutos de cada mes son gratis.',
    costNone: 'Sin detecciones seleccionadas: no se analizará ni se cobrará nada.',
    saved: 'Configuración de IA guardada',
    saveFailed: 'No se pudo guardar la configuración de IA',
    backfill: 'Analizar videos existentes',
    backfillUnsavedChanges: 'Guarda tus cambios primero: el análisis masivo usa la configuración guardada, no lo que se ve en pantalla.',
    backfillTitle: 'Analizar videos existentes',
    backfillCounting: 'Contando videos…',
    backfillNothing: 'Todos los videos de este evento ya están al día con la configuración guardada.',
    backfillSummary: 'A {count} videos les faltan detecciones que pide la configuración guardada ({duration} de video).',
    backfillAdds: 'Solo se ejecutan las detecciones que faltan: {features}.',
    backfillCost: 'Costo estimado: {cost}.',
    backfillBackground: 'Se ejecuta en segundo plano: puedes salir de esta página y seguirlo aquí o en la página de videos.',
    backfillModeration: 'Aplicar también moderación por IA a los resultados',
    backfillModerationHint: 'Desactivado por defecto. Activarlo puede rechazar videos que un moderador ya aprobó.',
    backfillRun: 'Analizar {count} ahora',
    backfillFailed: 'Falló el análisis masivo',
    jobStatus: {
      running: 'En curso',
      done: 'Terminado',
      stopped: 'Detenido',
      error: 'Falló',
    },
    jobAdds: 'Agrega {features}',
    jobModerationOn: 'moderación por IA activada',
    jobModerationOff: 'moderación por IA desactivada',
    jobProgress: '{done} de {total} videos',
    jobFailed: '{count} fallidos',
    jobStartedBy: 'Iniciado por {name}, {date}',
    jobFinishedAt: 'terminó {date}',
    jobRetryHint: 'Presiona "Analizar videos existentes" otra vez para reintentar los fallidos.',
    jobStoppedHint: 'Se detuvo antes de terminar. La próxima ejecución sigue con el resto.',
    jobStop: 'Detener',
    jobStopped: 'Análisis detenido',
    jobStopFailed: 'No se pudo detener el análisis',
    jobStripTitle: 'Análisis con IA',
    jobView: 'Ver',
  },
  guests: {
    generate: 'Generar lista de invitados',
    regenerate: 'Actualizar lista',
    generating: 'Generando lista…',
    count: 'Invitados que compartieron videos: {count}',
    copy: 'Copiar nombres',
    copied: 'Nombres copiados',
    empty: 'Todavía no hay videos aceptados con nombre.',
    unnamed: 'Videos sin nombre, no incluidos: {count}',
  },
  workspace: {
    navLabel: 'Evento',
    sectionPicker: 'Ir a',
    allEvents: 'Todos los eventos',
    notFound: 'Este evento no existe, o no tienes acceso a él.',
    groupRun: 'Operar el evento',
    groupLook: 'Apariencia',
    groupExperience: 'Experiencia del participante',
    groupVideos: 'Videos',
    groupTeam: 'Equipo',
    groupEvent: 'Evento',
    overview: 'Resumen',
    overviewIntro: 'Cómo está configurado este evento, y dónde cambiarlo.',
    openModeration: 'Abrir moderación',
    glanceTitle: 'De un vistazo',
    badgeReceptionClosed: 'Recepción cerrada',
    badgeAutoApprove: 'Aprobación automática',
    badgeAiModeration: 'Moderación con IA',
    badgeChallengesOne: '{count} reto',
    badgeChallengesMany: '{count} retos',
    badgePrize: 'Modo premio',
    badgeRecording: 'Clips de {clip}s · máx. {max}s',
    badgeStreaming: 'Streaming',
    badgeStreamingPublic: 'Streaming · galería pública',
    classicLink: 'Página clásica',
    classicNotice: 'Esta es la página clásica del evento, conservada por si se necesita. El nuevo espacio del evento es el predeterminado.',
    classicBack: 'Volver a la página nueva',
    tabRecording: 'Grabación',
    tabReception: 'Recepción',
    tabModeration: 'Reglas de moderación',
    tabAI: 'IA de video',
    tabAdmins: 'Administradores',
    tabInfo: 'Info y términos',
    tabGeneral: 'General',
    tabShare: 'Compartir y QR',
    tabPlan: 'Plan de analíticas',
    tabGuests: 'Invitados',
    descImages: 'Lo que los participantes ven detrás de cada pantalla de la webapp.',
    descTheme: 'Los colores de la webapp para este evento.',
    descChallenges: 'Las consignas que los participantes eligen antes de grabar.',
    descPrize: 'Completa todos los retos, gana un premio y canjéalo en el stand.',
    descRecording: 'Cuánto pueden grabar los participantes, y qué largo de clip pueden enviar.',
    descReception: 'Cuándo este evento recibe videos nuevos.',
    descModeration: 'Cómo llegan los videos nuevos a la cola de moderación.',
    descAI: 'Análisis automático de los videos nuevos, y rechazo de contenido explícito.',
    descStreaming: 'Reproducción en Cloudflare y la galería pública.',
    descAdmins: 'Quién puede operar y moderar este evento. Los cambios se aplican al instante.',
    descGeneral: 'El nombre y el tipo del evento.',
    descShare: 'El enlace y el código QR con que entran los participantes.',
    descPlan: 'Cómo se mantienen al día las cifras de este evento.',
    descGuests: 'Todos los que compartieron un video aceptado, con el nombre que dieron al entrar.',
    changeTypeHelp: 'Cambiar el tipo cambia qué ajustes tiene el evento. Se te pedirá confirmación.',
    deleteHelp: 'Elimina el evento y todo lo que le pertenece. No se puede deshacer.',
    unsavedMark: 'Cambios sin guardar',
    unsavedElsewhere: '{tab} tiene cambios sin guardar.',
    backToTab: 'Volver',
    leaveTitle: 'Cambios sin guardar en {tab}',
    leaveBody: '¿Guardarlos antes de salir, o descartarlos?',
    stay: 'Quedarme',
    discard: 'Descartar',
    saveAndLeave: 'Guardar y continuar',
  },
}

export default es
